import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

interface ConfirmOptions {
  title: string;
  message: string;
  danger?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
}

function ConfirmDialogUI({
  opts,
  onResolve,
}: {
  opts: ConfirmOptions;
  onResolve: (v: boolean) => void;
}) {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setOpen(false);
        onResolve(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onResolve]);

  if (!open) return null;

  return (
    <div
      className="modal-overlay"
      onClick={() => { setOpen(false); onResolve(false); }}
    >
      <div
        className="modal-card"
        style={{ maxWidth: 420, width: "90vw" }}
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
      >
        <div className="modal-header">
          <h3>{opts.title}</h3>
        </div>
        <div className="modal-body">
          <p style={{ margin: 0, color: "var(--text-secondary)", lineHeight: 1.5 }}>
            {opts.message}
          </p>
        </div>
        <div className="modal-footer" style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button
            className="btn btn-ghost"
            onClick={() => { setOpen(false); onResolve(false); }}
          >
            {opts.cancelLabel || "Huỷ"}
          </button>
          <button
            className={opts.danger ? "btn-danger" : "btn btn-primary"}
            onClick={() => { setOpen(false); onResolve(true); }}
          >
            {opts.confirmLabel || "Xác nhận"}
          </button>
        </div>
      </div>
    </div>
  );
}

export function confirm(opts: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const root = createRoot(container);

    const handleResolve = (value: boolean) => {
      resolve(value);
      setTimeout(() => {
        root.unmount();
        container.remove();
      }, 0);
    };

    root.render(<ConfirmDialogUI opts={opts} onResolve={handleResolve} />);
  });
}
